import { ClearableTextField } from '@app/components/form/ClearableTextField';
import { ComponentProps } from 'react';
import { defineMessage, useIntl } from 'react-intl';

/** Shared label for mention ID form fields and columns. */
export const mentionIdFieldMessage = defineMessage({
  id: 'audit.props.mentionId',
  defaultMessage: 'ID mention',
});

type MentionIdFieldProps = Omit<ComponentProps<typeof ClearableTextField>, 'name' | 'label'> & {
  name?: string;
  label?: string;
};

/**
 * Shared Formik text field for filtering by mention ID ("ID mention").
 */
export function MentionIdField({
  name = 'customId',
  submitOnClear = true,
  label,
  ...props
}: MentionIdFieldProps) {
  const { $t } = useIntl();

  return (
    <ClearableTextField
      name={name}
      submitOnClear={submitOnClear}
      label={label ?? $t(mentionIdFieldMessage)}
      {...props}
    />
  );
}
